import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import theme from 'styles/theme'
import GA4 from 'utils/GA4'

import {
  Card,
  CardLink,
  CardBg,
  CardBody,
  CardLocation,
  CardName,
} from './VillageGrid.style'

const VillageGridCard = ({
  city,
  name,
  cardImage,
  url,
  locale,
  homePages,
  headline,
  villageName,
}) => {
  const imageUrl =
    cardImage && cardImage.portrait ? cardImage.portrait.file.url : null

  let languages = []
  let defaultLocale = locale
  if (homePages && homePages.length) {
    const [homePage] = homePages
    defaultLocale = homePage.defaultLocale ? homePage.defaultLocale : locale
    languages =
      homePage.header &&
      homePage.header.languageGroup &&
      homePage.header.languageGroup.languages
        ? homePage.header.languageGroup.languages.map(
            (language) => language.locale
          )
        : []
  }

  const bgStyle = {
    backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
    backgroundColor: imageUrl ? null : `${theme.colors.white}`,
  }

  let urlLink = url.indexOf('http') === 0 ? url : '#'

  if (url && homePages) {
    urlLink =
      url.indexOf('http') === 0
        ? url
        : `/${url}/${languages.includes(locale) ? locale : defaultLocale}`
  }

  return (
    <Card
      onClick={() => {
        GA4('grid_villages_click', {
          headline: name,
          component_headline: headline,
          village_name: villageName || 'The Bicester Collection',
        })
      }}>
      <CardLink as={Link} to={urlLink}>
        <CardBg style={bgStyle} />
        <CardBody>
          <CardLocation>{city}</CardLocation>
          <CardName>{name}</CardName>
        </CardBody>
      </CardLink>
    </Card>
  )
}

VillageGridCard.propTypes = {
  name: PropTypes.string.isRequired,
  city: PropTypes.string,
  url: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  cardImage: PropTypes.shape({
    portrait: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }),
  homePages: PropTypes.arrayOf(
    PropTypes.shape({
      defaultLocale: PropTypes.string,
      header: PropTypes.shape({
        languageGroup: PropTypes.shape({
          languages: PropTypes.arrayOf(
            PropTypes.shape({
              locale: PropTypes.string,
            })
          ),
        }),
      }),
    })
  ),
  headline: PropTypes.string,
  villageName: PropTypes.string,
}

VillageGridCard.defaultProps = {
  city: '',
  cardImage: null,
  homePages: [],
  headline: '',
  villageName: '',
}

export default VillageGridCard
